import { render, staticRenderFns } from "./PhaseTypeTriple.vue?vue&type=template&id=658222c6&scoped=true"
import script from "./PhaseTypeTriple.vue?vue&type=script&lang=js"
export * from "./PhaseTypeTriple.vue?vue&type=script&lang=js"
import style0 from "./PhaseTypeTriple.vue?vue&type=style&index=0&id=658222c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658222c6",
  null
  
)

export default component.exports